import { useEffect } from 'react';

import i18n from 'i18next';

export default (title) => {
  useEffect(() => {
    document.title = i18n.t('title-with-account-name', {
      accountName: window.Intellum.accountName,
      title,
    });
  }, [title]);
};
